import { BaseURL, WebsiteURL, WithoutAuthUserDetailAPI } from "@/Utils/APIRequest/Endpoints";
import WithoutAuthInfluencer from "@/Component/WithoutAuthShare/Influencer";

type Props = {
    params: Promise<{ slug: string; display?: string[] }>;
}
export async function generateMetadata({ params }: Props): Promise<any> {
    // read route params
    const slug = (await params).slug;

    // fetch data
    let URL = `${BaseURL}${WithoutAuthUserDetailAPI}/${slug}`;
    const UserDetailData = await fetch(URL).then((res) => res.json());

    // optionally access and extend (rather than replace) parent metadata
    const previousImages = UserDetailData?.data?.image ? [UserDetailData?.data?.image] : [];

    return {
        title: "Connector Club",
        metadataBase: WebsiteURL,
        openGraph: {
            title: UserDetailData?.data?.display_name,
            description: UserDetailData?.data?.about_me || UserDetailData?.data?.ai_summary,
            images: [...previousImages],
        },
    }
}

const InfluencerDetailPage = async ({ params }: Props) => {
    const { slug } = await params;

    return (
        <WithoutAuthInfluencer slug={Array.isArray(slug) ? slug[0] : slug} />
    )
}

export default InfluencerDetailPage
